<template>
  <div class="p-the-l01-empty-panel">
    <template>
      <IconBase
        :width="iconSize.width"
        :height="iconSize.height"
        :view-box="`0 0 ${iconSize.width} ${iconSize.height}`"
        :icon-color="colorCode"
      >
        <IconBell
          class="p-the-l01-empty-panel__icon"
          :icon-size="iconSize.width"
          :icon-color="colorCode"
        />
      </IconBase>
    </template>
    <p class="p-the-l01-empty-panel__heading">
      検索対象の記事は存在しません。
    </p>

    <!-- <p class="p-the-l01-empty-panel__heading">「{{ searchKeyword }}」に一致する結果はありませんでした</p> -->
    <!-- <p class="p-the-l01-empty-panel__note" :style="{ color: colorCode }">別のキーワードで検索してください</p> -->
  </div>
</template>

<script lang="ts">
import { mapState } from "vuex";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconSearchEmpty from "@/common/components/icons/IconSearchEmpty.vue";
import IconBell from "@/common/components/icons/IconBell.vue";
import { Options, Vue } from 'vue-class-component';
import globals from "@/general/store/modules/globals";
import commons from "@/common/store/modules/commons";
// import commons from "@/common/store/modules/commons";
// import store from "@/general/store";
@Options({
  props: {
    searchKeyword: { type: String, required: true }
  },
  components: {
    IconBase,
    IconSearchEmpty,
    IconBell
  },
  computed: {
    ...mapState({
      colorCode: () => commons.colorCode
    })
  }
})
export default class TheL01EmptyPanel extends Vue {
  searchKeyword!: string;

  isSp = globals.isSpScreenWidth;

  get iconSize() {
    // const isSp = store.state.isSpScreenWidth;
    const isSp = globals.isSpScreenWidth;
    if (isSp) {
      return {
        width: 103,
        height: 105
      };
    } else {
      return {
        width: 159,
        height: 162
      };
    }
  }
}
</script>

<style lang="scss" scoped>
.p-the-l01-empty-panel {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: rem(16);

  @include sp {
    padding-top: 0;
  }

  &__heading {
    @include text__title--s;
    text-align: center;
    margin-top: rem(32);

    @include sp {
      @include text__body--m;
      margin-top: rem(24);
    }
  }

  &__note {
    @include text__body--m;
    font-weight: bold;
    text-align: center;
    margin-top: rem(8);

    @include sp {
      @include text__body--s;
      margin-top: rem(16);
    }
  }
}
</style>
